import React, { useEffect, useState } from 'react';

import { LARGE_TABLET_MIN_WIDTH } from 'constants/breakpoints';

import HideDuringDowntime from 'components/hide-during-downtime';
import MediaQuery from 'components/media-query';

const TIME_TO_COLLAPSE_MS = 500;

// the component below gets completely un-rendered and re-rendered at different
// points of playback, so to have continuity in states we need to 'remember'
// the previous state of the component
let wasCollapsed = false;
let wasHidden = true; // true to animate when page first loads
let wasStartCollapsed = false;
let wasCollapsible = false;
let collapseTimeout;

export default ({
  children,
  isCollapsible = false,
  startCollapsed = false,
  isHidden,
}) => {
  const [isCollapsed, _setIsCollapsed] = useState(
    wasCollapsed || wasHidden || (startCollapsed && !wasStartCollapsed)
  );

  const setIsCollapsed = newValue => {
    wasCollapsed = newValue;
    _setIsCollapsed(newValue);
  };

  useEffect(() => {
    let delayedFunction;

    if (isCollapsible && (!wasCollapsible || (isCollapsed && !wasCollapsed))) {
      delayedFunction = () => setIsCollapsed(true);
    } else if (!isCollapsible && wasCollapsed) {
      delayedFunction = () => setIsCollapsed(false);
    } else if (startCollapsed) {
      if (wasCollapsed || wasHidden || !wasStartCollapsed) {
        delayedFunction = () => setIsCollapsed(false);
      } else {
        setIsCollapsed(false);
      }

      wasStartCollapsed = true;
    } else {
      if (!isCollapsible && isCollapsed) {
        setIsCollapsed(false);
      }

      wasStartCollapsed = false;
    }

    if (delayedFunction) {
      collapseTimeout = setTimeout(delayedFunction, 50);
    }

    wasCollapsible = isCollapsible;

    return () => {
      clearTimeout(collapseTimeout);
      delayedFunction?.();
    };
  }, [isCollapsible, isCollapsed, startCollapsed]);

  useEffect(() => {
    wasHidden = isHidden;
  }, [isHidden]);

  if (isHidden) {
    return null;
  }

  return (
    <HideDuringDowntime>
      <MediaQuery query={`(min-width: ${LARGE_TABLET_MIN_WIDTH}px)`}>
        <div
          onClick={e => e.stopPropagation()}
          onMouseMove={() => {
            clearTimeout(collapseTimeout);

            setIsCollapsed(false);
          }}
          onMouseEnter={() => {
            clearTimeout(collapseTimeout);

            setIsCollapsed(false);
          }}
          onMouseLeave={() => {
            if (isCollapsible && !isCollapsed) {
              clearTimeout(collapseTimeout);

              collapseTimeout = setTimeout(
                () => setIsCollapsed(true),
                TIME_TO_COLLAPSE_MS
              );
            }
          }}
        >
          {children({ isCollapsed })}
        </div>
      </MediaQuery>
    </HideDuringDowntime>
  );
};
